// src/components/LoadingSpinner.js
import React from "react";

export default function LoadingSpinner() {
  return (
    <div style={{ textAlign: "center", padding: "20px", color: "#6b7280" }}>
      Loading...
    </div>
  );
}